/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channeltypedrop2Inputs */

const en_channeltypedrop2 = /** @type {(inputs: Channeltypedrop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

const de_channeltypedrop2 = /** @type {(inputs: Channeltypedrop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

/**
* | output |
* | --- |
* | "Drop" |
*
* @param {Channeltypedrop2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channeltypedrop2 = /** @type {((inputs?: Channeltypedrop2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channeltypedrop2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channeltypedrop2(inputs)
	return de_channeltypedrop2(inputs)
});
export { channeltypedrop2 as "channelTypeDrop" }